import { render, staticRenderFns } from "./AplicabilidadePrevista.vue?vue&type=template&id=960b905c&"
import script from "./AplicabilidadePrevista.vue?vue&type=script&lang=js&"
export * from "./AplicabilidadePrevista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports